import React from "react";

function Logo(props) {
    const { gotoHome } = props;

    const handleClick = () => {
        gotoHome();
    };

    return (
        <div id="logo" onClick={handleClick}>
            로고
        </div>
    );
}

export default Logo;
